import typography from 'shared-tokens/utils/tokens/typography';

export const mainCls = 'custom_radioinput';

export default {
  [mainCls]: {
    display: 'flex',
    'justify-content': 'flex-start',
    'align-items': 'center',
    margin: '0 0 8px',
    width: '100%',
    height: '40px',
    'line-height': '38px',
    background: '#f8f9fa',
    fontFamily: typography.tpFonts.m,
    fontSize: typography.tpSizes.m,
    '&.lastRadio': {
      margin: '0',
    },
    '&.desktop': {
      'font-size': '14px',
      'line-height': '32px',
      cursor: 'pointer',
    },
  },
  [`${mainCls}__radio`]: {
    display: 'block',
    'margin-right': '10px',
    width: '16px',
    height: '16px',
    background: '#FFF',
    border: '1px solid #96a1b0',
    'border-radius': '50%',
    '&.checked': {
      position: 'relative',
      background: '#39434e',
      border: '1px solid #39434e',
      'border-radius': '50%',
      '&:after': {
        content: '""',
        margin: '-3px 0 0 -3px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '6px',
        height: '6px',
        background: '#fff',
        'border-radius': '50%',
      },
    },  
  },
  [`${mainCls}__radio_red`]: {
    '&.checked': {
      background: '#E4002B',
      border: '1px solid #E4002B',
    }
  },
};